import { render, staticRenderFns } from "./CameraSwitch.vue?vue&type=template&id=2e3be8de&scoped=true"
var script = {}
import style0 from "./CameraSwitch.vue?vue&type=style&index=0&id=2e3be8de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3be8de",
  null
  
)

export default component.exports